import styled from 'styled-components';
import Text from '../text/Text.styled';

export const SMenuItemroupContainer = styled.div`
  border-radius: 5px;
  box-shadow: 0 3px 15px rgb(0 0 0 / 0.2);
  max-width: 300px;
  overflow: hidden;
  position: fixed;
`;

export const SMenuItemGroupTopBar = styled.div`
  background-color: ${({ theme }) => theme.colors.primaryText};
  padding-bottom: 15px;
  padding-left: 20px;
  padding-top: 15px;
  text-align: left !important;
`;

export const SMenuItemListbox = styled.div`
  max-height: fit-content;
  overflow-y: auto;
`;

export const MenuContainer = styled.div`
  position: relative;
`;

export const MenuListContainer = styled.div`
  position: absolute;
  right: 0;
`;

export const MenuListItem = styled.div`
  background-color: ${({ theme }) => theme.colors.primaryBackground};
  cursor: pointer;
  display: flex;
  justify-content: start;
  padding: 15px 20px;
  text-align: left !important;

  > ${Text} {
    margin-left: 0.7em;
  }
`;
